import React from 'react';
import {connect} from "react-redux";
import {setSQFTSystemDeleteMessage} from "../../../../actions/sqftMenuFunctions";
import workspace from "../../components/canvas/core/workspace";
import SqftStore from "../../components/canvas/store/sqftStore";
import {updateSQFTCalculations} from "../../../../actions/sqftFunctions";
import {FormattedMessage} from "react-intl";

const SqftSystemDeleteMessage = (props) => {
  const {systemDeleteMessage, setSQFTSystemDeleteMessage, updateCalculations, updateSQFTCalculations} = props;
  const handleDeleteClick = () => {
    window.lineInputFocused = false;
    const shapeToDelete = systemDeleteMessage.shape;
    workspace.removeShape(shapeToDelete);
    setSQFTSystemDeleteMessage({isOpened: false, shape: null});
    updateSQFTCalculations(updateCalculations + 1);

    const modelsLoader = SqftStore.viewGL && SqftStore.viewGL.modelsLoader;
    if (modelsLoader && typeof modelsLoader.removeCabinetForShape === 'function') {
      const didRemoveCabinet = modelsLoader.removeCabinetForShape(shapeToDelete.id);
      if (didRemoveCabinet) {
        modelsLoader.refreshCountertops().catch(error => {
          console.error('[SqftSystemDeleteMessage] Could not refresh countertops after cabinet deletion:', error);
        });
      }
    }
  };

  const handleCancelClick = () => {
    window.lineInputFocused = false;
    setSQFTSystemDeleteMessage({isOpened: false, shape: null});
  };

  return (
    <div className={"message-box-overlay " + (systemDeleteMessage.isOpened ? "" : "hidden")} >
      <div className="message-window-base">
        <div className="message-system-message-title">
          <FormattedMessage id={"sqft.popup.title.systemMessage"}/>
        </div>
        <div className="message-blue-lable"/>
        <div className="message-system-text message-system-text-blue">
          <span data-text="sqft.popup.deleteQuestion1">
            <FormattedMessage id={"sqft.popup.deleteQuestion1"}/>
          </span><br/>
          <span data-text="sqft.popup.deleteQuestion2">
            <FormattedMessage id={"sqft.popup.deleteQuestion2"}/>
          </span>
        </div>
        <div className="message-box-buttons message-box-buttons--modal">
          <button className="ui-button10 ui-button10--blue meta-buttons-confirm-nav--no" onClick={handleCancelClick}>
            <span className="ui-button10-text ui-button10--uppercase" data-text="sqft.popup.buttonCancel">
              <FormattedMessage id={"sqft.popup.buttonCancel"}/>
            </span>
          </button>
          <button className="ui-button10 ui-button10--red meta-buttons-confirm-nav--yes" onClick={handleDeleteClick}>
            <span className="ui-button10-text ui-button10--uppercase" data-text="sqft.popup.buttonDelete">
              <FormattedMessage id={"sqft.popup.buttonDelete"}/>
            </span>
          </button>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  systemDeleteMessage: store.sqftMenuState.systemDeleteMessage,
  updateCalculations: store.sqftState.updateCalculations,
});

const mapDispatchToProps = {
  setSQFTSystemDeleteMessage,
  updateSQFTCalculations,
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftSystemDeleteMessage);
